module.exports = __webpack_public_path__ + "img/practice.bcefa95d.png";